export const SubscriberAcquisitionsCalculations = (initialData, staticData) => {
  const getNewInstallValue = (initialData) => {
    const paidKey = {};
    const cumulativeInstallsTableInstall = {};
    const cumulativeMembersTableRegistration = {};
    const cumulativeMembersTableTotal = {};
    const organicKey = {};
    const newInstall = {};
    const cumulativeMembersDeregistration = {}; // Add this line

    for (let i = 1; i <= 36; i++) {
      // paid start
      const paidKeyYear =
        Number(initialData?.keyAssumptionMediaBuying?.months[i]) /
        Number(initialData?.keyAssumptionCostPerInstall?.months[i]);
      paidKey[i] = paidKeyYear;

      // paid end
      // ----------------------------------------------
      // organic start
      const previousYearCumulativeMembersTableTotal =
        i === 1 ? 0 : initialData?.cumulativeMembersTableTotal?.months[i - 1];
      const organicKeyYears =
        Number(
          (previousYearCumulativeMembersTableTotal *
            initialData?.newInstallsTableOrganicInstallToMembers?.months[i]) /
            100
        ) +
        Number(
          (initialData?.newInstallsTableOrganicInstallToPaidInstalls?.months[
            i
          ] *
            paidKey[i]) /
            100
        );

      organicKey[i] = organicKeyYears.toFixed(0);
      // organic end

      // ----------------------------------------------
      // newInstall start
      const newInstallYear = Number(organicKey[i]) + Number(paidKey[i]);
      newInstall[i] = newInstallYear.toFixed(0);
      // newInstall end

      // ----------------------------------------------

      // Registration start
      const registrationResult =
        (newInstall[i] *
          initialData?.keyAssumptionRegistrationInstallToMember["months"][i]) /
        100;
      cumulativeMembersTableRegistration[i] = registrationResult.toFixed(0);

      // Registration end

      // ----------------------------------------------

      // Deregistration start
      let previousYearTotalForDeregistration = 0;
      if (i > 12) {
        previousYearTotalForDeregistration =
          initialData?.cumulativeMembersTableTotal?.months[i - 12] || 0;
      }
      const deregistrationPercentage =
        (initialData?.cumulativeMembersTableChurnFromPreviousYear?.months[i] ||
          0) / 100;
      cumulativeMembersDeregistration[i] =
        previousYearTotalForDeregistration * deregistrationPercentage * -1;
      // Deregistration end

      // Cumulative Members Table -> Total start
      let previousYearTotal =
        i === 1
          ? initialData?.cumulativeMembersTableTotal["initialPeriod"] || 0
          : cumulativeMembersTableTotal[i - 1] || 0;

      const cumulativeMembersTableTotalYear =
        Number(previousYearTotal) +
        Number(cumulativeMembersTableRegistration[i]) +
        Number(cumulativeMembersDeregistration[i]); // Use the calculated deregistration value
      cumulativeMembersTableTotal[i] = cumulativeMembersTableTotalYear;

      // Cumulative Members Table -> Total end

      // Cumulative Installs Table => install start
      cumulativeInstallsTableInstall[i] = initialData?.newInstall?.months[i];
      // Cumulative Installs Table => install end

      // ----------------------------------------------
    }

    return {
      newInstall: { months: newInstall },
      organic: { months: organicKey },
      paid: { months: paidKey },
      cumulativeInstallsTableInstall: {
        months: cumulativeInstallsTableInstall,
      },
      cumulativeMembersTableRegistration: {
        months: cumulativeMembersTableRegistration,
      },
      cumulativeMembersTableTotal: {
        initialPeriod:
          initialData?.cumulativeMembersTableTotal["initialPeriod"],
        months: cumulativeMembersTableTotal,
      },
      cumulativeMembersDeregistration: {
        // Return the deregistration values
        months: cumulativeMembersDeregistration,
      },
    };
  };

  let calculatedDataFirst = getNewInstallValue(initialData);
  let previousCalculatedData = null;

  let i = 0;
  while (i < 36) {
    previousCalculatedData = calculatedDataFirst;
    calculatedDataFirst = getNewInstallValue({
      ...previousCalculatedData,
      ...staticData,
    });
    i++;
  }

  const {
    newInstall,
    organic,
    paid,
    cumulativeMembersTableTotal,
    cumulativeMembersDeregistration, // Include deregistration in the final output
  } = calculatedDataFirst;

  // Organic percentage
  const OrganicAmounts = {};
  // Paid percentage
  const paidAmounts = {};

  // Cumulative Members Table start
  const cumulativeMembersDeregistrationPercentage = {};
  const cumulativeMembersAmounts = {};

  // Cumulative Members Table end

  for (let i = 1; i <= 36; i++) {
    // Organic percentage start
    const result =
      Number(organic["months"][i]) / Number(newInstall["months"][i]);
    OrganicAmounts[i] =
      Number.isNaN(result) || !Number.isFinite(result) ? 0 : result * 100;
    // Organic percentage end

    // Paid percentage start
    const resultPaidAmounts =
      Number(paid["months"][i]) / Number(newInstall["months"][i]);

    paidAmounts[i] =
      Number.isNaN(resultPaidAmounts) || !Number.isFinite(resultPaidAmounts)
        ? 0
        : resultPaidAmounts * 100;

    // Paid percentage end

    // _______________________________________________________________

    // Cumulative Members Table start

    // DeregistrationPercentage start
    let total;

    // Check if there is data for the same month of the previous year
    if (i > 12) {
      total = cumulativeMembersTableTotal["months"][i - 12];
    } else {
      // Use 0 if there's no data for 12 months ago
      total = 0;
    }
    cumulativeMembersDeregistrationPercentage[i] =
      (total *
        initialData?.cumulativeMembersTableChurnFromPreviousYear["months"][i]) /
      100;
    // DeregistrationPercentage end

    // _______________________________________________________________

    // Deregistration start
    const deregistrationPercentage =
      cumulativeMembersDeregistrationPercentage[i];
    cumulativeMembersDeregistration[i] =
      deregistrationPercentage === 0
        ? 0
        : (deregistrationPercentage * -1).toFixed(0);

    // Deregistration end

    // _______________________________________________________________

    // Cumulative Members start

    let totalYearAmount = 0;

    if (i === 1) {
      totalYearAmount =
        initialData?.cumulativeMembersTableTotal["initialPeriod"].toFixed(0);
    } else {
      totalYearAmount = cumulativeMembersTableTotal["months"][i - 1].toFixed(0);
    }
    cumulativeMembersAmounts[i] = totalYearAmount;

    // Cumulative Members end

    // _______________________________________________________________

    // Cumulative Members Table end
  }

  postMessage({
    ...calculatedDataFirst,
    OrganicAmounts,
    paidAmounts,
    cumulativeMembersDeregistration,
    cumulativeMembersDeregistrationPercentage,
    cumulativeMembersAmounts,
    cumulativeMembersTableTotal,
  });
};

export const setValuesFromAssumptions = (
  subscriberAcquisitionAssumptionsState
) => {
  const registrationInstallToMember = {};
  const subscriptionInstallToSubscriber = {};
  const churnRateOfAnnualSubs = {};

  for (let i = 1; i <= 36; i++) {
    // paid key of New Installs Table
    let registrationInstallYearAmount =
      subscriberAcquisitionAssumptionsState["registration"]["months"][i];
    registrationInstallToMember[i] = registrationInstallYearAmount;
    // Subscription (install to subscriber) of cumulativeSubscribers

    let subscriptionInstallToSubscriberYearAmount =
      subscriberAcquisitionAssumptionsState["subscription"]["months"][i];
    subscriptionInstallToSubscriber[i] =
      subscriptionInstallToSubscriberYearAmount;

    // Churn Rate of Annual Subs.
    let churnRateOfAnnualSubsYearAmount =
      subscriberAcquisitionAssumptionsState["annualChurnRate"]["months"][i];
    churnRateOfAnnualSubs[i] = churnRateOfAnnualSubsYearAmount;
  }

  postMessage({
    registrationInstallToMember,
    subscriptionInstallToSubscriber,
    churnRateOfAnnualSubs,
  });
};

// cumulativeInstallsTable start

export const cumulativeInstallTableCalculations = (cumulativeInstalls) => {
  // cumulativeInstall => Total
  const cumulativeTotal = {};
  // cumulativeInstall => Cumulative App Installs
  const cumulativeAppInstalls = {};

  // uninstallChurn last row of table
  const cumulativeAppUninstallChurn = {};
  // uninstall
  const cumulativeAppUninstall = {};

  for (let i = 1; i <= 36; i++) {
    // cumulativeInstall => Total start

    let previousTotal = cumulativeInstalls["total"]["initialPeriod"];
    if (i > 1) {
      previousTotal = cumulativeTotal[i - 1];
    }

    const installs = cumulativeInstalls["install"]?.months[i];

    // Calculate uninstallChurn
    let totalResultForUninstallChurn =
      cumulativeInstalls["total"]["initialPeriod"];
    if (i > 12) {
      totalResultForUninstallChurn = cumulativeTotal[i - 12];
    }
    const resultOfUninstallChurn =
      (cumulativeInstalls["churn"]["months"][i] / 100) *
      totalResultForUninstallChurn;
    cumulativeAppUninstallChurn[i] = resultOfUninstallChurn.toFixed(0);

    // Calculate total using uninstallChurn
    const result =
      Number(previousTotal) + Number(installs) - Number(resultOfUninstallChurn);
    cumulativeTotal[i] = result.toFixed(0);

    // cumulativeInstall => Total end
    // _______________________________________________________________

    // cumulativeInstall => Cumulative App Installs start
    let yearAmount = 0;

    if (i === 1) {
      yearAmount = cumulativeInstalls["total"]["initialPeriod"];
      cumulativeAppInstalls[i] = yearAmount;
    } else {
      yearAmount = cumulativeTotal[i - 1];
      cumulativeAppInstalls[i] = yearAmount;
    }
    // cumulativeInstall => Cumulative App Installs end

    // _______________________________________________________________

    // uninstall start
    cumulativeAppUninstall[i] =
      resultOfUninstallChurn === 0
        ? 0
        : (resultOfUninstallChurn * -1).toFixed(0);
    // uninstall end
  }
  postMessage({
    cumulativeTotal,
    cumulativeAppUninstall,
    cumulativeAppInstalls,
    cumulativeAppUninstallChurn,
  });
};

// CumulativeMembersTable end

// _______________________________________________________________

// CumulativeSubscribersTable start

export const cumulativeSubscribersTableCalculation = (
  cumulativeInstalls,
  subscriberAcquisitionAssumptionsState,
  cumulativeSubscribers
) => {
  // Subscriber from Installs => subscriberFromInstall
  const subscriberFromInstalls = {};

  // subscriptionInstallToSubscriber text field just use
  // annualToTotalSubscribers textField just use it as
  // Churn Rate of Annual Subs. => churnAnnualSubscribers =>
  // subscriberAcquisitionAssumptionsState => churnRate

  // Subscription (install to journey) => subscriptionInstallToJourneys
  const subscriptionInstallToJourney = {};

  // Subscriber from Journeys => subscriberFromJourney
  const subscriberFromJourneys = {};

  // New Annual Subscribers => newAnnualSubscribers
  const newAnnualSubscribers = {};

  // Number of Annual Renewals => annualRenewals
  const numberOfAnnualRenewals = {};

  // Total Annual Subscribers => totalAnnualSubscribers
  const totalAnnualSubscribers = {};

  // New Annual Subscribers from Renewals => newAnnualFromRenewals
  const newAnnualSubscribersFromRenewals = {};

  // New Annual Subscribers from Installs => newAnnualFromInstalls
  const newAnnualSubscribersFromInstalls = {};

  // Cumulative Subscribers => cumulativeAnnualSubscribers
  const cumulativeSubscribersAmount = {};

  // New Monthly Subscribers => newMonthlySubscribers
  const newMonthlySubscribers = {};

  // Number of Monthly Renewals => monthlyRenewals
  const numberOfMonthlyRenewals = {};

  // Total Monthly Subscribers => totalMonthlySubscribers
  const totalMonthlySubscribers = {};

  // New Monthly Subscribers from Renewals => newMonthlyFromRenewals
  const newMonthlySubscribersFromRenewals = {};

  // New Monthly Subscribers from Installs => newMonthlyFromInstalls
  const newMonthlySubscribersFromInstalls = {};

  // Cumulative Subscribers => cumulativeMonthlySubscribers
  const cumulativeMonthlySubscribersAmount = {};

  for (let i = 1; i <= 36; i++) {
    //1 Subscriber from Installs start
    const result =
      (cumulativeInstalls["install"]["months"][i] *
        subscriberAcquisitionAssumptionsState["subscription"]["months"][i]) /
      100;
    subscriberFromInstalls[i] = result.toFixed(0);
    // Subscriber from Installs end

    // _______________________________________________________________

    //2 Subscription (install to journey) start
    const results =
      (subscriberAcquisitionAssumptionsState["subscription"]["months"][i] *
        cumulativeSubscribers["journeyToSubscription"]["months"][i]) /
      100;
    subscriptionInstallToJourney[i] = results;
    // Subscription (install to journey) end

    // _______________________________________________________________

    //3 Subscriber from Journeys start

    // const installJourneys =
    // cumulativeSubscribers["subscriptionInstallToJourneys"]["years"][i];
    const installJourneys = subscriptionInstallToJourney[i];

    let previousCumulativeInstall =
      cumulativeInstalls["install"]["initialPeriod"];

    let previousSubscriberFromInstall =
      cumulativeSubscribers["subscriberFromInstall"]["initialPeriod"];

    if (i > 1) {
      previousCumulativeInstall =
        cumulativeInstalls["install"]["months"][i - 1];
      previousSubscriberFromInstall = subscriberFromInstalls[i - 1];
    }

    const resultOfSubscriberFromJourneys =
      (installJourneys *
        (previousCumulativeInstall - previousSubscriberFromInstall)) /
      100;

    subscriberFromJourneys[i] = resultOfSubscriberFromJourneys.toFixed(0);
    // Subscriber from Journeys end

    // _______________________________________________________________

    //4 New Annual Subscribers start
    const resultOfNewAnnualSubscribers =
      ((Number(subscriberFromInstalls[i]) + Number(subscriberFromJourneys[i])) *
        cumulativeSubscribers["annualToTotalSubscribers"]["months"][i]) /
      100;
    newAnnualSubscribers[i] = resultOfNewAnnualSubscribers.toFixed(0);

    // New Annual Subscribers end

    // _______________________________________________________________

    //5 Number of Annual Renewals => annualRenewals start
    let previousAnnualRenewals =
      cumulativeSubscribers["annualRenewals"]["initialPeriod"];

    if (i > 1) {
      previousAnnualRenewals = numberOfAnnualRenewals[i - 12];
    }

    let previousAnnualSubscribers =
      cumulativeSubscribers["newAnnualSubscribers"]["initialPeriod"];

    if (i > 1) {
      previousAnnualSubscribers = newAnnualSubscribers[i - 12];
    }

    let churn =
      subscriberAcquisitionAssumptionsState["annualChurnRate"]["months"][i];

    const resultOfNumberOfAnnualRenewals =
      ((Number(previousAnnualRenewals) + Number(previousAnnualSubscribers)) *
        (100 - churn)) /
      100;

    numberOfAnnualRenewals[i] = Number.isNaN(resultOfNumberOfAnnualRenewals)
      ? 0
      : resultOfNumberOfAnnualRenewals.toFixed(0);

    // Number of Annual Renewals => annualRenewals end

    // _______________________________________________________________

    //6 Total Annual Subscribers => totalAnnualSubscribers start
    const resultOfTotalAnnualSubscribers =
      Number(newAnnualSubscribers[i]) + Number(numberOfAnnualRenewals[i]);

    totalAnnualSubscribers[i] = resultOfTotalAnnualSubscribers.toFixed(0);

    // Total Annual Subscribers => totalAnnualSubscribers end

    // _______________________________________________________________

    //________________________________________________________________
    // Total Monthly Subscribers => totalMonthlySubscribers start

    //4 New Monthly Subscribers start
    const resultOfNewMonthlySubscribers =
      ((Number(subscriberFromInstalls[i]) + Number(subscriberFromJourneys[i])) *
        cumulativeSubscribers["monthlyToTotalSubscribers"]["months"][i]) /
      100;
    newMonthlySubscribers[i] = resultOfNewMonthlySubscribers.toFixed(0);

    // New Monthly Subscribers end

    //5 Number of Monthly Renewals => monthlyRenewals start
    let previousMonthlyRenewals =
      cumulativeSubscribers["monthlyRenewals"]["initialPeriod"];

    if (i > 1) {
      previousMonthlyRenewals = numberOfMonthlyRenewals[i - 1];
    }

    let previousMonthlySubscribers =
      cumulativeSubscribers["newMonthlySubscribers"]["initialPeriod"];

    if (i > 1) {
      previousMonthlySubscribers = newMonthlySubscribers[i - 1];
    }

    let monthlySubscriberChurn =
      subscriberAcquisitionAssumptionsState["monthlyChurnRate"]["months"][i];
    const resultOfNumberOfMonthlyRenewals =
      ((Number(previousMonthlyRenewals) + Number(previousMonthlySubscribers)) *
        (100 - monthlySubscriberChurn)) /
      100;

    numberOfMonthlyRenewals[i] = Number.isNaN(resultOfNumberOfMonthlyRenewals)
      ? 0
      : resultOfNumberOfMonthlyRenewals.toFixed(0);

    const resultOfTotalMonthlySubscribers =
      Number(newMonthlySubscribers[i]) + Number(numberOfMonthlyRenewals[i]);
    totalMonthlySubscribers[i] = resultOfTotalMonthlySubscribers.toFixed(0);

    const resultOfNewMonthlySubscribersFromRenewals =
      numberOfMonthlyRenewals[i];
    newMonthlySubscribersFromRenewals[i] = Number(
      resultOfNewMonthlySubscribersFromRenewals
    ).toFixed(0);

    const resultOfNewMonthlySubscribersFromInstalls = newMonthlySubscribers[i];
    newMonthlySubscribersFromInstalls[i] = Number(
      resultOfNewMonthlySubscribersFromInstalls
    ).toFixed(0);

    const resultOfMonthlyCumulativeSubscribers =
      Number(newMonthlySubscribersFromInstalls[i]) +
      Number(newMonthlySubscribersFromRenewals[i]);
    cumulativeMonthlySubscribersAmount[i] =
      resultOfMonthlyCumulativeSubscribers.toFixed(0);

    // Number of Monthly Renewals => monthlyRenewals End

    // 9 Cumulative Subscribers => cumulativeSubscribers start

    const resultOfCumulativeSubscribers =
      Number(totalAnnualSubscribers[i]) + Number(totalMonthlySubscribers[i]);
    cumulativeSubscribersAmount[i] = resultOfCumulativeSubscribers.toFixed(0);

    //7 New Annual Subscribers from Renewals => newAnnualFromRenewals start

    const resultOfNewAnnualSubscribersFromRenewals =
      Number(numberOfAnnualRenewals[i]) + Number(numberOfMonthlyRenewals[i]);
    newAnnualSubscribersFromRenewals[i] =
      resultOfNewAnnualSubscribersFromRenewals.toFixed(0);

    // New Annual Subscribers from Renewals => newAnnualFromRenewals end

    // _______________________________________________________________

    //8 New Annual Subscribers from Installs => newAnnualFromInstalls start

    const resultOfNewAnnualSubscribersFromInstalls =
      Number(newAnnualSubscribers[i]) + Number(newMonthlySubscribers[i]);
    newAnnualSubscribersFromInstalls[i] =
      resultOfNewAnnualSubscribersFromInstalls.toFixed(0);

    // New Annual Subscribers from Installs => newAnnualFromInstalls end

    // _______________________________________________________________

    // Cumulative Subscribers => cumulativeSubscribers end
  }

  postMessage({
    subscriberFromInstalls,
    subscriptionInstallToJourney,
    subscriberFromJourneys,
    newAnnualSubscribers,
    newMonthlySubscribers,
    numberOfAnnualRenewals,
    numberOfMonthlyRenewals,
    totalAnnualSubscribers,
    totalMonthlySubscribers,
    newAnnualSubscribersFromRenewals,
    newAnnualSubscribersFromInstalls,
    cumulativeSubscribersAmount,
  });
};

// CumulativeSubscribersTable end

// Revenue Tab start

export const calculateSubscriptionRevenueTable = (
  cumulativeSubscribers,
  subscriptionRevenue,
  otherRevenue,
  monthCount
) => {
  // Number of New Subscribers
  let numberOfNewSubscribers = {};
  //
  let subscriptionRevenueAmountMonths = {};
  // total revenue / Revenue
  let pnl_main_totalRevenues = {};
  // Growth
  let pnl_main_revenueGrowth = {};
  // YoY Growth (x)
  let pnl_main_yoyGrowth = {};
  for (let i = 1; i <= monthCount; i++) {
    // Number of New Subscribers
    numberOfNewSubscribers[i] =
      cumulativeSubscribers["totalAnnualSubscribers"]["months"][i];
    // Subscription Revenue
    subscriptionRevenueAmountMonths[i] =
      numberOfNewSubscribers[i] *
      subscriptionRevenue["annualAverageFee"]["months"][i];

    pnl_main_totalRevenues[i] =
      Number(subscriptionRevenueAmountMonths[i]) +
      Number(otherRevenue["otherRevenue"]["months"][i]);

    // Growth start
    let previousTotalRevenues = 0;
    if (i > 1) {
      previousTotalRevenues = pnl_main_totalRevenues[i - 1];
    }

    const currentTotalRevenues = pnl_main_totalRevenues[i];

    const result = (currentTotalRevenues / previousTotalRevenues - 1) * 100;

    pnl_main_revenueGrowth[i] =
      Number.isNaN(result) || !Number.isFinite(result)
        ? 0
        : result >= 500 || result <= -500
        ? "n.m."
        : result;
    // Growth end

    // YoY Growth (x) start
    let previousTotalRevenuesYoYGrowth = 0;
    if (i > 1) {
      previousTotalRevenuesYoYGrowth = pnl_main_totalRevenues[i - 1];
    }

    const currentTotalRevenuesYoYGrowth = pnl_main_totalRevenues[i];

    const resultYoYGrowth =
      currentTotalRevenuesYoYGrowth / previousTotalRevenuesYoYGrowth;

    pnl_main_yoyGrowth[i] =
      Number.isNaN(resultYoYGrowth) || !Number.isFinite(resultYoYGrowth)
        ? 0
        : resultYoYGrowth.toFixed(2);

    // YoY Growth (x) end
  }
  postMessage({
    numberOfNewSubscribers,
    subscriptionRevenueAmountMonths,
    pnl_main_totalRevenues,
    pnl_main_revenueGrowth,
    pnl_main_yoyGrowth,
  });
};

// Application Stores % of Sales => Total

export const subscriptionCommissionsTableCalculations = (
  subscriptionCommissions,
  subscriptionRevenue,
  monthCount
) => {
  // Application Stores % of Sales Total => appStoresTotal
  const appStoresTotalAmounts = {};

  // Sales Commissions USD  Apple App Store => appleAppStoreCommissionAmount
  const salesCommissionsUsdAppleAppStore = {};

  // Sales Commissions USD  Google Play => googlePlayAppStoreCommissionAmount
  const salesCommissionsUsdGooglePlay = {};

  // Sales Commissions USD Website => websiteStoreCommissionAmount
  const salesCommissionsUsdWebsite = {};

  // Total Sales Commission => totalSalesCommissionsAmount
  // Total Sales Commission
  const totalSalesCommission = {};
  // App Store Commissions
  const pnl_main_appStoreCommissions = {};

  // Net Subscription Revenue => netSubscriptionRevenue
  const netSubscriptionRevenue = {};

  for (let i = 1; i <= monthCount; i++) {
    // Application Stores % of Sales Total start
    // appleAppStore,googlePlayAppStore,websiteStore
    appStoresTotalAmounts[i] =
      Number(subscriptionCommissions["appleAppStore"]["months"][i]) +
      Number(subscriptionCommissions["googlePlayAppStore"]["months"][i]) +
      Number(subscriptionCommissions["websiteStore"]["months"][i]);

    // Application Stores % of Sales Total end

    // _______________________________________________________________

    // Sales Commissions USD  Apple App Store => appleAppStoreCommissionAmount start
    const result =
      (subscriptionRevenue["subscriptionRevenue"]["months"][i] *
        subscriptionCommissions["appleAppStore"]["months"][i] *
        subscriptionCommissions["appleAppStoreCommission"]["months"][i]) /
      10000;
    salesCommissionsUsdAppleAppStore[i] = result.toFixed(0);
    // Sales Commissions USD  Apple App Store => appleAppStoreCommissionAmount end

    // _______________________________________________________________

    // Sales Commissions USD  Google Play => googlePlayAppStoreCommissionAmount start

    const resultOfSalesCommissionsUSDGooglePlay =
      (subscriptionRevenue["subscriptionRevenue"]["months"][i] *
        subscriptionCommissions["googlePlayAppStore"]["months"][i] *
        subscriptionCommissions["googlePlayAppStoreCommission"]["months"][i]) /
      10000;
    salesCommissionsUsdGooglePlay[i] =
      resultOfSalesCommissionsUSDGooglePlay.toFixed(0);

    // Sales Commissions USD  Google Play => googlePlayAppStoreCommissionAmount end

    // _______________________________________________________________

    // Sales Commissions USD Website => websiteStoreCommissionAmount start
    const resultOfSalesCommissionsUSDWebsite =
      (subscriptionRevenue["subscriptionRevenue"]["months"][i] *
        subscriptionCommissions["websiteStore"]["months"][i] *
        subscriptionCommissions["websiteStoreCommission"]["months"][i]) /
      10000;
    salesCommissionsUsdWebsite[i] =
      resultOfSalesCommissionsUSDWebsite.toFixed(0);

    // Sales Commissions USD Website => websiteStoreCommissionAmount end

    // _______________________________________________________________

    // Total Sales Commission => totalSalesCommissionsAmount start

    const resultOfTotalSalesCommission =
      Number(salesCommissionsUsdAppleAppStore[i]) +
      Number(salesCommissionsUsdGooglePlay[i]) +
      Number(salesCommissionsUsdWebsite[i]);

    totalSalesCommission[i] = resultOfTotalSalesCommission.toFixed(0);
    const resultAppStoreCommissions = resultOfTotalSalesCommission * -1;
    pnl_main_appStoreCommissions[i] = resultAppStoreCommissions.toFixed(0);

    // Total Sales Commission => totalSalesCommissionsAmount end

    // _______________________________________________________________

    // Net Subscription Revenue => netSubscriptionRevenue start

    const resultOfNetSubscriptionRevenue =
      Number(subscriptionRevenue["subscriptionRevenue"]["months"][i]) -
      Number(totalSalesCommission[i]);
    netSubscriptionRevenue[i] = resultOfNetSubscriptionRevenue.toFixed(0);
    // Net Subscription Revenue => netSubscriptionRevenue end
  }

  postMessage({
    appStoresTotalAmounts,
    salesCommissionsUsdAppleAppStore,
    salesCommissionsUsdGooglePlay,
    salesCommissionsUsdWebsite,
    totalSalesCommission,
    pnl_main_appStoreCommissions,
    netSubscriptionRevenue,
  });
};

// Other Revenue start
export const calculateOtherRevenues = (
  otherRevenue,
  subscriptionRevenue,
  monthCount
) => {
  // Revenues
  let pnl_main_totalRevenues = {};
  // Growth
  let pnl_main_revenueGrowth = {};
  // YoY Growth (x)
  let pnl_main_yoyGrowth = {};

  for (let i = 1; i <= monthCount; i++) {
    // Revenues
    const subscriptionValue = subscriptionRevenue?.["subscriptionRevenue"]?.["months"]?.[i] || 0;
    const otherValue = otherRevenue?.["otherRevenue"]?.["months"]?.[i] || 0;
    pnl_main_totalRevenues[i] = Number(subscriptionValue) + Number(otherValue);

    // Growth start
    let previousTotalRevenues = 0;
    if (i > 1) {
      previousTotalRevenues = pnl_main_totalRevenues[i - 1];
    }

    const currentTotalRevenues = pnl_main_totalRevenues[i];

    const result = (currentTotalRevenues / previousTotalRevenues - 1) * 100;

    pnl_main_revenueGrowth[i] =
      Number.isNaN(result) || !Number.isFinite(result)
        ? 0
        : result >= 500 || result <= -500
        ? "n.m."
        : result;
    // Growth end
    // YoY Growth (x) start
    let previousTotalRevenuesYoYGrowth = 0;
    if (i > 1) {
      previousTotalRevenuesYoYGrowth = pnl_main_totalRevenues[i - 1];
    }

    const currentTotalRevenuesYoYGrowth = pnl_main_totalRevenues[i];

    const resultYoYGrowth =
      currentTotalRevenuesYoYGrowth / previousTotalRevenuesYoYGrowth;

    pnl_main_yoyGrowth[i] =
      Number.isNaN(resultYoYGrowth) || !Number.isFinite(resultYoYGrowth)
        ? 0
        : resultYoYGrowth.toFixed(2);

    // YoY Growth (x) end
  }

  postMessage({
    pnl_main_totalRevenues,
    pnl_main_revenueGrowth,
    pnl_main_yoyGrowth,
  });
};
// Other Revenue end

// Revenue Tab end

// Cost And Expenses Tab Start

export const contentAndProductionCostsCalculation = (
  costOfSales,
  monthCount
) => {
  // Content & Production Costs
  const contentProductionKey = {};
  // Content & Production Costs / pnl_main_contentAndProductionCosts
  const pnl_main_contentAndProductionCosts = {};
  for (let i = 1; i <= monthCount; i++) {
    const result =
      Number(costOfSales["writtenContentKey"]["months"][i]) +
      Number(costOfSales["studioKey"]["months"][i]) +
      Number(costOfSales["dubbingArtistsKey"]["months"][i]) +
      Number(costOfSales["musicKey"]["months"][i]);
    contentProductionKey[i] = result;
    pnl_main_contentAndProductionCosts[i] = result * -1;
  }

  postMessage({
    contentProductionKey,
    pnl_main_contentAndProductionCosts,
  });
};

export const serverCostAndNumberOfAvgCumulativeMembersCalculation = (
  cumulativeMembersData,
  costOfSalesContd,
  monthCount
) => {
  // "Number of Avg Cumulative Members => numberOfAvgCumMembers
  const numberOfAvgCumulativeMembers = {};

  // Server Cost => serverCostKey
  const serverCostKey = {};

  // Server Cost / pnl_main_serverCost => pnl_main_serverCost
  const pnl_main_serverCost = {};

  for (let i = 1; i <= monthCount; i++) {
    // "Number of Avg Cumulative Members => numberOfAvgCumMembers start

    const cumulativeMembersMonths =
      cumulativeMembersData["cumulativeMembers"]["months"][i];

    const total = cumulativeMembersData["total"]["months"][i];

    const result = (Number(cumulativeMembersMonths) + Number(total)) / 2;

    numberOfAvgCumulativeMembers[i] = result.toFixed(0);

    // "Number of Avg Cumulative Members => numberOfAvgCumMembers end

    //----------------------------------------------------------------------

    // Server Cost => serverCostKey start
    const fixedCost = costOfSalesContd["fixedCostKey"]["months"][i];
    const cumulativeMembers = numberOfAvgCumulativeMembers[i];

    const numberOfConcurrent =
      costOfSalesContd["numberOfConcurrentKey"]["months"][i];
    const concurrentRatio = costOfSalesContd["concurrentRatioKey"]["months"][i];
    const concurrentAmount =
      costOfSalesContd["concurrentAmountKey"]["months"][i];
    const resultOfServerCost =
      Number(fixedCost) +
      ((cumulativeMembers * concurrentRatio) / 100 < numberOfConcurrent
        ? 0
        : ((cumulativeMembers * concurrentRatio) / 100 / numberOfConcurrent) *
          concurrentAmount);

    serverCostKey[i] = resultOfServerCost.toFixed(0);
    pnl_main_serverCost[i] =
      resultOfServerCost.toFixed(0) === 0
        ? 0
        : resultOfServerCost.toFixed(0) * -1;

    // Server Cost => serverCostKey end
  }

  postMessage({
    numberOfAvgCumulativeMembers,
    serverCostKey,
    pnl_main_serverCost,
  });
};

export const GeneralAdministrativeExpensesTableCalculation = (
  generalAdministrativeExpenses,
  monthCount
) => {
  // Other Operating Expenses => gae_otherOperatingExpenses
  const gae_otherOperatingExpenses = {};

  const pnl_main_otherOperatingExpenses = {};

  for (let i = 1; i <= monthCount; i++) {
    gae_otherOperatingExpenses[i] =
      Number(generalAdministrativeExpenses["gae_legalKey"]["months"][i]) +
      Number(generalAdministrativeExpenses["gae_accountingCPA"]["months"][i]) +
      Number(generalAdministrativeExpenses["gae_bookkeeperKey"]["months"][i]) +
      Number(
        generalAdministrativeExpenses["gae_researchAnalysis"]["months"][i]
      ) +
      Number(generalAdministrativeExpenses["gae_consultants"]["months"][i]) +
      Number(
        generalAdministrativeExpenses["gae_rentGeneralExpenses"]["months"][i]
      ) +
      Number(generalAdministrativeExpenses["gae_fixedAsset"]["months"][i]) +
      Number(
        generalAdministrativeExpenses["gae_educationExpenses"]["months"][i]
      ) +
      Number(
        generalAdministrativeExpenses["gae_emailSubscriptions"]["months"][i]
      );

    pnl_main_otherOperatingExpenses[i] = gae_otherOperatingExpenses[i] * -1;
  }

  postMessage({
    gae_otherOperatingExpenses,
    pnl_main_otherOperatingExpenses,
  });
};

// Sales and Marketing Expenses => General Administrative Expenses Table start

export const calculateMarketingExpensesAndMediaBuying = (
  salesAndMarketingExpenses,
  monthCount
) => {
  // Marketing Expenses => same_marketingExpenses
  const same_marketingExpenses = {};
  // Media Buying => same_mediaBuying
  const same_mediaBuying = {};
  // Marketing Expenses  => pnl_main_marketingExpenses
  const pnl_main_marketingExpenses = {};

  for (let i = 1; i <= monthCount; i++) {
    let result = 0;
    result += Number(salesAndMarketingExpenses["same_ombaa"]["months"][i]);
    result += Number(salesAndMarketingExpenses["same_seo"]["months"][i]);
    // }
    result += Number(
      salesAndMarketingExpenses["same_mediaBuying"]["months"][i]
    );

    same_marketingExpenses[i] = result;

    // Marketing Expenses / pnl_main_marketingExpenses
    pnl_main_marketingExpenses[i] = result * -1;

    same_mediaBuying[i] =
      salesAndMarketingExpenses["same_mediaBuying"]["months"][i];
  }

  postMessage({
    same_marketingExpenses,
    same_mediaBuying,
    pnl_main_marketingExpenses,
  });
};

export const calculatePnl_main_advertisementExpenses = (
  advertisementExpenses,
  monthCount
) => {
  // pnl_main_advertisementExpenses
  const pnl_main_advertisementExpenses = {};
  for (let i = 1; i <= monthCount; i++) {
    pnl_main_advertisementExpenses[i] =
      advertisementExpenses["ae_prOnOffInfluencerActivities"]?.months[i] * -1;
  }

  postMessage({
    pnl_main_advertisementExpenses,
  });
};

export const calculateOtherAdvertisementAndMarketingExpensesTotal = (
  otherAdvertisementAndMarketingExpenses,
  monthCount
) => {
  // Other Advertisement & Marketing Expenses => Total
  const oame_otherAdvAndMarketing = {};
  // Other Advertisement & Marketing Expenses / pnl_main_otherAdvMarketingExpenses
  const pnl_main_otherAdvMarketingExpenses = {};

  for (let i = 1; i <= monthCount; i++) {
    let result = 0;
    result += Number(
      otherAdvertisementAndMarketingExpenses["oame_attributionTool"]["months"][
        i
      ]
    );
    result += Number(
      otherAdvertisementAndMarketingExpenses["oame_analyticsAndEngagementTool"][
        "months"
      ][i]
    );
    result += Number(
      otherAdvertisementAndMarketingExpenses["oame_mailing"]["months"][i]
    );
    result += Number(
      otherAdvertisementAndMarketingExpenses["oame_customerSupport"]["months"][
        i
      ]
    );
    result += Number(
      otherAdvertisementAndMarketingExpenses["oame_sponsorship"]["months"][i]
    );
    result += Number(
      otherAdvertisementAndMarketingExpenses["oame_other"]["months"][i]
    );
    oame_otherAdvAndMarketing[i] = result;

    // Other Advertisement & Marketing Expenses / pnl_main_otherAdvMarketingExpenses

    pnl_main_otherAdvMarketingExpenses[i] = result * -1;
  }

  postMessage({
    oame_otherAdvAndMarketing,
    pnl_main_otherAdvMarketingExpenses,
  });
};

// Cost And Expenses Tab End

// Hiring Plan tab start

// Founders and Partners
export const calculateFoundersAndPartners = (
  foundersAndPartners,
  monthCount
) => {
  // Founders and Partners => hp_fp_foundersAndPartnersHeader
  let hp_fp_foundersAndPartnersHeader = {};

  // hp_fp_headCount => hp_fp_headCount
  let hp_fp_headCount = {};

  for (let i = 1; i <= monthCount; i++) {
    // hp_fp_headCount
    hp_fp_headCount[i] =
      Number(foundersAndPartners["hp_fp_founders"]["months"][i]) +
      Number(foundersAndPartners["hp_fp_advisoryBoard"]["months"][i]);

    // hp_fp_foundersAndPartnersHeader
    hp_fp_foundersAndPartnersHeader[i] =
      Number(hp_fp_headCount[i]) *
      Number(foundersAndPartners["hp_fp_costPerHead"]["months"][i]);
  }
  postMessage({
    hp_fp_foundersAndPartnersHeader,
    hp_fp_headCount,
  });
};

// Tech & Product Development
export const calculateTechAndDevelopment = (techProductDev, monthCount) => {
  // hp_tpd_header
  let hp_tpd_header = {};

  // hp_tpd_headCount
  let hp_tpd_headCount = {};

  for (let i = 1; i <= monthCount; i++) {
    // hp_tpd_headCount
    hp_tpd_headCount[i] =
      Number(techProductDev["hp_tpd_engineer"]["months"][i]) +
      Number(techProductDev["hp_tpd_developer"]["months"][i]) +
      Number(techProductDev["hp_tpd_uiuxDesigner"]["months"][i]) +
      Number(techProductDev["hp_tpd_productManagement"]["months"][i]) +
      Number(techProductDev["hp_tpd_productManagement"]["months"][i]);

    // hp_tpd_header
    hp_tpd_header[i] =
      Number(hp_tpd_headCount[i]) *
      Number(techProductDev["hp_tpd_costPerHead"]["months"][i]);
  }

  postMessage({
    hp_tpd_header,
    hp_tpd_headCount,
  });
};

// Sales and Marketing Teams
export const calculateSalesAndMarketingTeams = (
  salesAndMarketing,
  monthCount
) => {
  let hp_sm_salesAndMarketingHeader = {};
  let hp_sm_headCount = {};
  // Personnel Expenses (?)
  const pnl_main_personnelExpenses2 = {};

  for (let i = 1; i <= monthCount; i++) {
    // hp_tpd_headCount
    hp_sm_headCount[i] =
      Number(salesAndMarketing["hp_sm_salesTeamKey"]["months"][i]) +
      Number(salesAndMarketing["hp_sm_marketingTeam"]["months"][i]) +
      Number(salesAndMarketing["hp_sm_businessDevelopment"]["months"][i]) +
      Number(salesAndMarketing["hp_sm_userAcquisition"]["months"][i]) +
      Number(salesAndMarketing["hp_sm_crm"]["months"][i]) +
      Number(salesAndMarketing["hp_sm_subscriberSupport"]["months"][i]) +
      Number(
        salesAndMarketing["hp_sm_socialMediaAndContentDesign"]["months"][i]
      ) +
      Number(salesAndMarketing["hp_sm_communityManagement"]["months"][i]);

    // hp_tpd_header
    hp_sm_salesAndMarketingHeader[i] =
      Number(hp_sm_headCount[i]) *
      Number(salesAndMarketing["hp_sm_costPerHead"]["months"][i]);

    pnl_main_personnelExpenses2[i] = hp_sm_salesAndMarketingHeader[i] * -1;
  }

  postMessage({
    hp_sm_salesAndMarketingHeader,
    hp_sm_headCount,
    pnl_main_personnelExpenses2,
  });
};

// Finance & Analytics & Operations
export const calculateFinanceAndAnalyticsAndOperations = (
  financeAndAnalytics,
  monthCount
) => {
  let hp_fa_financeAndAnalytics = {};
  let hp_fa_headCount = {};

  for (let i = 1; i <= monthCount; i++) {
    // hp_fp_headCount
    hp_fa_headCount[i] =
      Number(financeAndAnalytics["hp_fa_financeTeam"]["months"][i]) +
      Number(
        financeAndAnalytics["hp_fa_dataScienceAnalyticsTeam"]["months"][i]
      ) +
      Number(financeAndAnalytics["hp_fa_hrTeam"]["months"][i]) +
      Number(financeAndAnalytics["hp_fa_legalTeam"]["months"][i]);
    // Number(financeAndAnalytics['hp_fa_costPerHead']["years"][i])

    // hp_fp_foundersAndPartnersHeader
    hp_fa_financeAndAnalytics[i] =
      Number(hp_fa_headCount[i]) *
      Number(financeAndAnalytics["hp_fa_costPerHead"]["months"][i]);
  }

  postMessage({
    hp_fa_financeAndAnalytics,
    hp_fa_headCount,
  });
};

export const otherTableCalculation = (other, monthCount) => {
  let hp_other_header = {};
  let hp_other_headCount = {};

  for (let i = 1; i <= monthCount; i++) {
    // hp_fp_headCount
    hp_other_headCount[i] = Number(other["hp_other_freelancers"]["months"][i]);
    // Number(financeAndAnalytics['hp_fa_costPerHead']["years"][i])

    // hp_fp_foundersAndPartnersHeader
    hp_other_header[i] =
      Number(hp_other_headCount[i]) *
      Number(other["hp_other_costPerHead"]["months"][i]);
  }
  postMessage({
    hp_other_header,
    hp_other_headCount,
  });
};

// Average Table start
export const calculateTotalHeadCount = (
  financeAndAnalytics,
  foundersAndPartners,
  other,
  salesAndMarketing,
  techAndProduct,
  monthCount
) => {
  // Total Head Count => hp_avg_totalHeadCount
  let hp_avg_totalHeadCount = {};

  for (let i = 1; i <= monthCount; i++) {
    // totalHeadCount
    hp_avg_totalHeadCount[i] =
      Number(financeAndAnalytics["hp_fa_headCount"]["months"][i]) +
      Number(foundersAndPartners["hp_fp_headCount"]["months"][i]) +
      Number(other["hp_other_headCount"]["months"][i]) +
      Number(salesAndMarketing["hp_sm_headCount"]["months"][i]) +
      Number(techAndProduct["hp_tpd_headCount"]["months"][i]);
  }
  postMessage({
    hp_avg_totalHeadCount,
  });
};

export const calculateTotalCost = (
  financeAndAnalytics,
  foundersAndPartners,
  other,
  salesAndMarketing,
  techAndProduct,
  monthCount
) => {
  // Total Cost => hp_avg_totalCost
  let hp_avg_totalCost = {};

  for (let i = 1; i <= monthCount; i++) {
    // totalHeadCount
    hp_avg_totalCost[i] =
      Number(financeAndAnalytics["hp_fa_financeAndAnalytics"]["months"][i]) +
      Number(
        foundersAndPartners["hp_fp_foundersAndPartnersHeader"]["months"][i]
      ) +
      Number(other["hp_other_header"]["months"][i]) +
      Number(salesAndMarketing["hp_sm_salesAndMarketingHeader"]["months"][i]) +
      Number(techAndProduct["hp_tpd_header"]["months"][i]);
  }
  postMessage({
    hp_avg_totalCost,
  });
};

export const calculateAverageSalaryPerHeadCount = (average, monthCount) => {
  // Average Salary per Head Count => hp_avg_avgSalary
  let hp_avg_avgSalary = {};

  for (let i = 1; i <= monthCount; i++) {
    const totalHeadCount = Number(
      average["hp_avg_totalHeadCount"]["months"][i]
    );
    const totalCost = Number(average["hp_avg_totalCost"]["months"][i]);

    if (!totalHeadCount) {
      hp_avg_avgSalary[i] = 0;
      continue;
    }

    const result = totalCost / totalHeadCount;

    hp_avg_avgSalary[i] = Number.isFinite(result) ? result.toFixed(0) : 0;
  }

  postMessage({
    hp_avg_avgSalary,
  });
};

export const calculateGeneralAdministrativeExpenses = (average, monthCount) => {
  // General Administrative Expenses => hp_avg_genAdminExpenses
  const hp_avg_genAdminExpenses = {};

  // Personnel Expenses
  const pnl_main_personnelExpenses = {};

  for (let i = 1; i <= monthCount; i++) {
    const result =
      Number(average["hp_avg_totalCost"]["months"][i]) -
      Number(average["hp_avg_salesAndMarketingExpenses"]["months"][i]);

    hp_avg_genAdminExpenses[i] = result.toFixed(0);
    pnl_main_personnelExpenses[i] = hp_avg_genAdminExpenses[i] * -1;
  }
  postMessage({
    hp_avg_genAdminExpenses,
    pnl_main_personnelExpenses,
  });
};

// Average Table end

// Hiring Plan tab end

// Profit & Loss start
export const calculateGrossProfitAndMargin = (
  profitAndLossMain,
  monthCount
) => {
  // Gross Profit => pnl_main_grossProfit
  const pnl_main_grossProfit = {};
  // Gross Profit Margin => pnl_main_grossProfitMargin
  const pnl_main_grossProfitMargin = {};

  for (let i = 1; i <= monthCount; i++) {
    const totalRevenues = profitAndLossMain?.["pnl_main_totalRevenues"]?.["months"]?.[i] || 0;
    const appStoreCommissions = profitAndLossMain?.["pnl_main_appStoreCommissions"]?.["months"]?.[i] || 0;
    const contentProductionCosts = profitAndLossMain?.["pnl_main_contentAndProductionCosts"]?.["months"]?.[i] || 0;
    const serverCost = profitAndLossMain?.["pnl_main_serverCost"]?.["months"]?.[i] || 0;
    
    const result =
      Number(totalRevenues) +
      Number(appStoreCommissions) +
      Number(contentProductionCosts) +
      Number(serverCost);
    pnl_main_grossProfit[i] = result;

    // Gross Profit Margin start
    const currentTotalRevenues = totalRevenues;

    const currentGrossProfit = pnl_main_grossProfit[i];

    const result_pnl_main_grossProfitMargin =
      currentGrossProfit / currentTotalRevenues;

    pnl_main_grossProfitMargin[i] =
      Number.isNaN(result_pnl_main_grossProfitMargin) ||
      !Number.isFinite(result_pnl_main_grossProfitMargin)
        ? 0
        : result_pnl_main_grossProfitMargin.toFixed(3) * 100;

    // Gross Profit Margin end
  }

  postMessage({
    pnl_main_grossProfit,
    pnl_main_grossProfitMargin,
  });
};

export const calculateGeneralAdministrativeExpense = (
  profitAndLossMain,
  monthCount
) => {
  // General Administrative Expense => pnl_main_genAdminExpenses,fcf_main_generalAdministrativeExpenses
  let pnl_main_genAdminExpenses = {};
  for (let i = 1; i <= monthCount; i++) {
    const personnelExpenses = profitAndLossMain?.["pnl_main_personnelExpenses"]?.["months"]?.[i] || 0;
    const otherOperatingExpenses = profitAndLossMain?.["pnl_main_otherOperatingExpenses"]?.["months"]?.[i] || 0;
    
    const result = Number(personnelExpenses) + Number(otherOperatingExpenses);
    pnl_main_genAdminExpenses[i] = result;
  }
  postMessage({
    pnl_main_genAdminExpenses,
  });
};

export const calculateSalesAndMarketingExpenses = (
  profitAndLossMain,
  monthCount
) => {
  // Sales & Marketing Expenses => pnl_main_sAndMExpenses

  let pnl_main_sAndMExpenses = {};

  for (let i = 1; i <= monthCount; i++) {
    const personnelExpenses2 = profitAndLossMain?.["pnl_main_personnelExpenses2"]?.["months"]?.[i] || 0;
    const marketingExpenses = profitAndLossMain?.["pnl_main_marketingExpenses"]?.["months"]?.[i] || 0;
    const advertisementExpenses = profitAndLossMain?.["pnl_main_advertisementExpenses"]?.["months"]?.[i] || 0;
    const otherAdvMarketingExpenses = profitAndLossMain?.["pnl_main_otherAdvMarketingExpenses"]?.["months"]?.[i] || 0;
    
    const result =
      Number(personnelExpenses2) +
      Number(marketingExpenses) +
      Number(advertisementExpenses) +
      Number(otherAdvMarketingExpenses);
    pnl_main_sAndMExpenses[i] = result;
  }
  postMessage({
    pnl_main_sAndMExpenses,
  });
};

export const calculateEBITDAPnl_main_ebitda = (
  profitAndLossMain,
  monthCount
) => {
  // EBITDA / pnl_main_ebitda => pnl_main_ebitda
  let pnl_main_ebitda = {};

  for (let i = 1; i <= monthCount; i++) {
    const grossProfit = profitAndLossMain?.["pnl_main_grossProfit"]?.["months"]?.[i] || 0;
    const genAdminExpenses = profitAndLossMain?.["pnl_main_genAdminExpenses"]?.["months"]?.[i] || 0;
    const sAndMExpenses = profitAndLossMain?.["pnl_main_sAndMExpenses"]?.["months"]?.[i] || 0;
    
    const result = Number(grossProfit) + Number(genAdminExpenses) + Number(sAndMExpenses);
    pnl_main_ebitda[i] = result;
  }
  postMessage({
    pnl_main_ebitda,
  });
};

export const calculateEBITDAMargin_pnl_main_ebitdaMargin = (
  profitAndLossMain,
  monthCount
) => {
  // EBITDA Margin / pnl_main_ebitdaMargin => pnl_main_ebitdaMargin
  let pnl_main_ebitdaMargin = {};

  for (let i = 1; i <= monthCount; i++) {
    const currentEbitda = profitAndLossMain?.["pnl_main_ebitda"]?.["months"]?.[i] || 0;
    const currentTotalRevenues = profitAndLossMain?.["pnl_main_totalRevenues"]?.["months"]?.[i] || 0;

    const result = (currentEbitda / currentTotalRevenues) * 100;

    pnl_main_ebitdaMargin[i] =
      Number.isNaN(result) || !Number.isFinite(result) ? 0 : result.toFixed(2);
  }

  postMessage({
    pnl_main_ebitdaMargin,
  });
};
// Profit & Loss end
